import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "my-2" }, "IP:", -1)
const _hoisted_2 = { class: "my-2" }
const _hoisted_3 = { class: "my-2" }
const _hoisted_4 = { class: "my-2" }
const _hoisted_5 = { class: "titleStatus" }
const _hoisted_6 = {
  style: {"width":"max-content"},
  class: "mr-4"
}

import { ref} from 'vue';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
import { useI18n } from 'vue-i18n';
import { STRING_GENERAL } from '@/constants/labels';
import CONSTANTIMGS from '@/constants/images';

/********************************
 ********** COMPONENTS **********
 *******************************/
import VirMacComponent from './VirMacDialog.vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { LTE_STATUS } from '@/interfaces/SmartLink/LTE';
import { IMGS } from '@/interfaces/SmartLink/Imgs';



export default /*#__PURE__*/_defineComponent({
  __name: 'LTECard',
  props: {
    name        : { required:true, type:String },
    sysuptime   : { required:true, type:String },
    ip          : { required:true, type:String },
    type        : { required:true, type:String },
    arrayTable  : { type:Array, required:true, },
    statusElem  : { type:Array as () => LTE_STATUS[], required:true },
},
  setup(__props) {

const props = __props;

const { xs } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/


const showServerMVS     = ref(false);

const finalImage        = ref();
const CONST_IMG:IMGS    = {
    "LTE"           : CONSTANTIMGS.IMAGES.lte,
    "SERVER"        : CONSTANTIMGS.IMAGES.server,
};
finalImage.value        = CONST_IMG[props.type];

const showMVSDialog = async () => {
    showServerMVS.value = true;            
}


return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(_unref(xs) ? 'cardxs' : 'card')
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_unref(xs) ? 'circlexs' : 'circle')
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(_unref(xs) ? __props.type === _unref(STRING_GENERAL).SERVER ? 'contentxs' : 'contentxsLTE' :'content')
      }, [
        _createVNode(_component_v_row, { class: "ma-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_sheet, {
              width: "max-content",
              color: "transparent",
              class: "mr-2"
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('labels.uptime')) + ":", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_sheet, {
              width: "max-content",
              color: "transparent",
              class: "ml-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, _toDisplayString(__props.ip), 1),
                _createElementVNode("div", _hoisted_4, _toDisplayString(__props.sysuptime), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('labels.status')) + ": ", 1),
        _createVNode(_component_v_row, {
          class: _normalizeClass(["ma-0", _unref(xs) ? 'statusRowXS' : 'statusRow']),
          justify: "center"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.statusElem, (elem, i) => {
              return (_openBlock(), _createBlock(_component_v_col, {
                class: "pa-1",
                cols: "3",
                sm: "2",
                md: "2",
                lg: "2",
                xl: "2",
                key: i
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    color: "transparent",
                    class: "card-status text-center pa-0 py-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: elem.status===1?'green':'black'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(elem.icon), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"]),
                      _createElementVNode("p", _hoisted_5, _toDisplayString(elem.title), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["class"])
      ], 2),
      _createVNode(_component_v_img, {
        class: _normalizeClass(__props.type === _unref(STRING_GENERAL).SERVER ? 'card-img' : 'card-imgLTE'),
        src: finalImage.value
      }, null, 8, ["class", "src"]),
      (__props.type === _unref(STRING_GENERAL).SERVER)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            class: _normalizeClass(_unref(xs) ? 'imgclickXS' : 'imgclick'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.type === _unref(STRING_GENERAL).SERVER ? showMVSDialog() : null))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Clickme ")
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      _createElementVNode("h4", {
        class: _normalizeClass(__props.type === _unref(STRING_GENERAL).SERVER ? 'title' : 'titleLTE')
      }, _toDisplayString(__props.name), 3)
    ], 2),
    _createVNode(_component_v_dialog, {
      width: "90%",
      modelValue: showServerMVS.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showServerMVS).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "card_dialog",
          color: "background"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "ma-0",
              justify: "space-between",
              style: {"align-items":"self-end !important"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "10" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "ma-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(t)('labels.virtMach')) + " - " + _toDisplayString(__props.ip), 1),
                        _createVNode(_component_v_tooltip, {
                          text: "OK",
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_sheet, _mergeProps(props, {
                              class: "sheetIcons pa-1",
                              color: "green",
                              width: "50"
                            }), {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" mdi-thumb-up-outline")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          text: "Alertas",
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_sheet, _mergeProps(props, {
                              class: "sheetIcons pa-1",
                              color: "yellow",
                              width: "50"
                            }), {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" mdi-alarm-light-outline")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          text: "Alarmas",
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_sheet, _mergeProps(props, {
                              class: "sheetIcons pa-1",
                              color: "red",
                              width: "50"
                            }), {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" mdi-alert-box-outline")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1040)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      icon: "mdi-close",
                      variant: "plain",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (showServerMVS.value = false))
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider, { class: "mt-4" }),
            _createVNode(_component_v_row, { class: "ma-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "pa-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_sheet, {
                      class: "defaultCard text-center",
                      color: "bgtopology"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(VirMacComponent, {
                          ip: [__props.ip],
                          rows: 25,
                          recharge: false,
                          emited: true
                        }, null, 8, ["ip"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})